import { CustomType } from "PFCore/types";

export const isTaggable = (customType?: CustomType) => customType?.name === "skills";
